/**
 * Fiscal Period API Client
 */

import apiClient from './client';

export const getAllPeriods = async (filters = {}) => {
  const response = await apiClient.get('/fiscal-periods', { params: filters });
  return response.data;
};

export const getCurrentPeriod = async () => {
  const response = await apiClient.get('/fiscal-periods/current');
  return response.data;
};

export const createPeriodsForYear = async (year) => {
  const response = await apiClient.post('/fiscal-periods/generate', { year });
  return response.data;
};

export const openPeriod = async (periodId) => {
  const response = await apiClient.post(`/fiscal-periods/${periodId}/open`);
  return response.data;
};

export const closePeriod = async (periodId) => {
  const response = await apiClient.post(`/fiscal-periods/${periodId}/close`);
  return response.data;
};

// ============================================
// GLOBAL FISCAL SETTINGS API
// ============================================

/**
 * Get global fiscal settings
 * @param {string} module - 'retail' or 'wholesale'
 */
export const getGlobalSettings = async (module = 'retail') => {
  const response = await apiClient.get('/fiscal-periods/global-settings', { params: { module } });
  return response.data;
};

/**
 * Update global fiscal settings
 * @param {object} settings - Settings to update
 * @param {string} module - 'retail' or 'wholesale'
 */
export const updateGlobalSettings = async (settings, module = 'retail') => {
  const response = await apiClient.put('/fiscal-periods/global-settings', { ...settings, module });
  return response.data;
};

/**
 * Get current active period date range
 * @param {string} module - 'retail' or 'wholesale'
 */
export const getCurrentRange = async (module = 'retail') => {
  const response = await apiClient.get('/fiscal-periods/current-range', { params: { module } });
  return response.data;
};

export default {
  getAllPeriods,
  getCurrentPeriod,
  createPeriodsForYear,
  openPeriod,
  closePeriod,
  getGlobalSettings,
  updateGlobalSettings,
  getCurrentRange
};
